import { createSelector } from 'selectors'

import { constant } from './constant'

const { selector } = constant

const getAllTargets = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: `.${selector.target}` }, true)

const getTargets = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: `.${selector.target}` }, true)

const getMainLoader = () => createSelector<HTMLElement>({ selector: selector.mainLoader })

const getAllTriggers = () => createSelector<NodeListOf<HTMLElement>>({ selector: selector.trigger }, true)

export const selectors = {
	getAllTargets,
	getTargets,
	getMainLoader,
	getAllTriggers,
}
